import Icon from '../components/Icon.vue'

Icon.register({
  cube: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M239.1 6.3c10.9-4.1 22.9-4.1 33.7 0.1l208 78c18.7 7 31.1 24.9 31.1 44.9v225.1c0 18.1-10.2 34.8-26.5 42.9l-208 104c-13.5 6.8-29.4 6.8-42.9 0l-208-104c-16.2-8.1-26.5-24.7-26.5-42.9v-225.1c0-20 12.4-38 31.1-45zM256 68.4l-192 72v1.1l192 78 192-78v-1.1zM288 424.4l160-80v-133.9l-160 65v148.9z'
      }
    ]
  }
})
